import { useMemo, useState } from "react";
import { ArrowUpDown } from "lucide-react";
import { Section, EmptyState } from "./Section";
import { fmtPct, fmtScore, fmtHours, fmtNum } from "./definitions";

const COLS = [
  { key: "company", label: "Client" },
  { key: "tickets", label: "Tickets", fmt: fmtNum },
  { key: "ai_resolution_rate", label: "AI resolution", fmt: fmtPct },
  { key: "escalation_rate", label: "Escalation", fmt: fmtPct },
  { key: "csat", label: "CSAT", fmt: fmtScore },
  { key: "avg_ttc_h", label: "Avg time to close", fmt: fmtHours },
];

export const ClientTable = ({ rows }) => {
  const [sort, setSort] = useState({ key: "tickets", dir: -1 });
  const sorted = useMemo(() => [...rows].sort((a, b) => {
    const x = a[sort.key], y = b[sort.key];
    if (x === null || x === undefined) return 1;
    if (y === null || y === undefined) return -1;
    return (typeof x === "string" ? x.localeCompare(y) : x - y) * sort.dir;
  }), [rows, sort]);
  const toggle = (key) => setSort((s) => ({ key, dir: s.key === key ? -s.dir : -1 }));

  return (
    <Section title="By client" testId="client-section" subtitle="Click a column to sort — spot accounts where the bot is struggling"
      info="Client = the ticket's primary company, else the contact's associated client / organisation / company field in HubSpot. 'Unknown' when HubSpot has none.">
      {rows.length === 0 ? <EmptyState message="No conversations in this period." testId="client-empty" /> : (
        <div className="overflow-x-auto max-h-[380px] overflow-y-auto">
          <table className="w-full text-sm" data-testid="client-table">
            <thead className="sticky top-0 bg-white">
              <tr className="border-b border-slate-100">
                {COLS.map((c) => (
                  <th key={c.key} className={`py-2 font-medium text-[11px] uppercase tracking-wide text-slate-500 ${c.key === "company" ? "text-left" : "text-right"}`}>
                    <button type="button" onClick={() => toggle(c.key)} className="inline-flex items-center gap-1 hover:text-slate-800" data-testid={`client-sort-${c.key}`}>
                      {c.label}<ArrowUpDown className={`w-3 h-3 ${sort.key === c.key ? "text-[#425B76]" : ""}`} />
                    </button>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sorted.map((r) => (
                <tr key={r.company} className="border-b border-slate-50 hover:bg-slate-50" data-testid="client-row">
                  {COLS.map((c) => (
                    <td key={c.key} className={`py-1.5 ${c.key === "company" ? "text-slate-800 font-medium" : "text-right text-slate-600"}`}>
                      {c.fmt ? c.fmt(r[c.key]) : r[c.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Section>
  );
};
